import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';
import { logOut } from '../actions/loginActions';

export function onDownloadResponse(response) {
  return {
    type: types.DOWNLOAD_RESPONSE,
    response,
  };
}

export function fetchDownloadDetails(response) {
  return {
    type: types.DOWNLOAD_DETAIL_RESPONSE,
    response,
  };
}

export const studentDownloadlist = async (jwtToken, dispatch) => {
  const body = {};
  const url = 'api/student/downloads';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          }),
        );
        return dispatch(logOut());
      }
      dispatch(onDownloadResponse(data));
    });
};

export const studentDownloadFile = async (uniqueCode, jwtToken, dispatch) => {
  const body = {
    UniqueCode: uniqueCode,
  };
  const url = 'api/student/downloads';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          }),
        );
        return dispatch(logOut());
      }
      dispatch(fetchDownloadDetails(data));
    });
};
